import { render, staticRenderFns } from "./CameraModal.vue?vue&type=template&id=3c0cb4ce"
import script from "./CameraModal.vue?vue&type=script&lang=js"
export * from "./CameraModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports